/* KLEINN & co.® — theme.js */
(function () {
  'use strict';

  var K = window.KLEINN || {};

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + value.replace(/,00$/, ',00');
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartDrawerOverlay');

  function openDrawer() { document.body.classList.add('cart-open'); refreshCart(); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeDrawer(); return; }

    var atc = e.target.closest('[data-add-to-cart]');
    if (atc) {
      e.preventDefault();
      var variantId = atc.getAttribute('data-add-to-cart');
      var qty = parseInt(atc.getAttribute('data-qty') || '1', 10);
      addToCart(variantId, qty, atc);
      return;
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-line-key]');
      changeQty(line.getAttribute('data-line-key'), parseInt(qtyBtn.getAttribute('data-qty-change'), 10), line);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); }
  });

  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; }
    fetch(K.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { openDrawer(); })
      .catch(function () { window.location.href = K.routes.cart; })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  function changeQty(lineKey, delta, lineEl) {
    var current = parseInt(lineEl.getAttribute('data-line-qty'), 10);
    var next = Math.max(0, current + delta);
    fetch(K.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: next })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function refreshCart() {
    fetch(K.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function renderCart(cart) {
    var body = document.getElementById('CartDrawerBody');
    var subtotalEl = document.getElementById('CartSubtotal');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var checkoutBtn = document.getElementById('CartCheckoutBtn');
    if (!body) return;

    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;

    if (cart.item_count === 0) {
      body.innerHTML = document.getElementById('CartEmptyTemplate').innerHTML;
    } else {
      var html = '';
      cart.items.forEach(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
        var url = item.url || '#';
        html += '<div class="cart-line" data-line-key="' + item.key + '" data-line-qty="' + item.quantity + '">' +
          (img ? '<a href="' + url + '" class="cart-line__img-link"><img src="' + img + '" alt=""></a>' : '<div class="cart-line__img-ph"></div>') +
          '<div class="cart-line__info">' +
          '<div class="cart-line__name"><a href="' + url + '">' + item.product_title + '</a></div>' +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-qty">' +
          '<button type="button" data-qty-change="-1" aria-label="Minder">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-change="1" aria-label="Meer">+</button>' +
          '</div></div></div>';
      });

      // cross-sell: kies het filter dat hoort bij een product in de wagen (dynamisch, live prijs)
      if (K.crossSells) {
        var xs = null;
        for (var ci = 0; ci < cart.items.length; ci++) {
          var cand = K.crossSells[cart.items[ci].product_id];
          if (cand) {
            var already = cart.items.some(function (i) { return i.variant_id === cand.filterId; });
            if (!already) { xs = cand; break; }
          }
        }
        if (xs) {
          html += '<div class="cart-cross-sell">' +
            '<div class="cart-cross-sell__title">Vergeet je reservefilter niet</div>' +
            '<div class="cart-cross-sell__note">' + xs.title + ' · ' + xs.price + '. ' + (xs.note || '') + '</div>' +
            '<button type="button" class="btn btn--outline" data-add-to-cart="' + xs.filterId + '">+ Voeg toe</button>' +
            '</div>';
        }
      }
      body.innerHTML = html;
    }

    renderShipMeter(cart.total_price);
  }

  function renderShipMeter(totalPrice) {
    var meter = document.getElementById('FreeShipMeter');
    if (!meter || !K.freeShippingThreshold) return;
    var threshold = K.freeShippingThreshold;
    var label = meter.querySelector('.free-ship-meter__label');
    var fill = meter.querySelector('.free-ship-meter__fill');
    var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    fill.style.width = pct + '%';
    if (totalPrice >= threshold) {
      label.textContent = '✓ Gratis verzending · morgen in huis';
      label.classList.add('is-reached');
      fill.classList.add('is-reached');
    } else {
      label.textContent = 'Nog ' + formatMoney(threshold - totalPrice) + ' tot gratis verzending';
      label.classList.remove('is-reached');
      fill.classList.remove('is-reached');
    }
  }

  /* ---------- Product form (variant + ATC) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      addToCart(id, 1, form.querySelector('button[type="submit"]'));
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.getAttribute('data-gallery-thumb');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Mobiel off-canvas menu ---------- */
  function openMenu() {
    document.body.classList.add('menu-open');
    var b = document.querySelector('[data-menu-open]');
    if (b) b.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    document.body.classList.remove('menu-open');
    var b = document.querySelector('[data-menu-open]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }
    if (e.target.closest('.menu-drawer__nav a')) { closeMenu(); }
  });

  /* ---------- Sticky mobiele koopbalk ---------- */
  var sticky = document.getElementById('StickyAtc');
  var buyBox = document.querySelector('[data-buybox]');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-atc');
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(buyBox);
  }
})();
